export default "__VITE_ASSET__B_Z7A4_1__"